import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={10} height={13} viewBox="0 0 10 14" style={{
    stroke: "none"
  }} xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M1.667 11.11L7.833 7 1.667 2.89v8.22zM1.354.903l8.333 5.555c.417.278.417.806 0 1.084l-8.333 5.555C.808 13.46 0 13.137 0 12.554V1.446C0 .863.808.54 1.354.903z" /></svg>;
}
export default SvgComponent;